import { all, call, put, takeLatest } from 'redux-saga/effects';

import { request } from '@app/services';
import {
  getMyProfile,
  getMyProfileFailed,
  getMyProfileSuccess,
  updateProfile,
  updateProfileFailed,
  updateProfileSuccess,
} from './slice';
import * as endpoints from './endpoints';

// ----------------------------------------
function* getmyProfileSagas(action: ReturnType<typeof getMyProfile>): any {
  try {
    const result = yield call(request.get, endpoints.getMyProfile);
    yield put(getMyProfileSuccess(result.data));
  } catch (err) {
    yield put(getMyProfileFailed(err));
  }
}
function* updateProfileSaga(action: ReturnType<typeof updateProfile>): any {
  try {
    const {
      id,
      firstName,
      lastName,
      mobileNumber,
      educationInfo,
      bankInfo,
      emergencyContactInfo,
      workExperienceInfo,
      documentInfo,
      source,
      referenceBy,
      myProfileImage,
      maritalStatus,
      personalEmail,
      aboutMe,
      dob,
      gender,
      permanentAddress,
      presentAddress,
      other,
      samePresentAddress,
    } = action.payload;

    const formData = new FormData();

    firstName && formData.append('firstName', firstName);
    lastName && formData.append('lastName', lastName);
    mobileNumber && formData.append('phone', mobileNumber);
    myProfileImage && formData.append('profileImage', myProfileImage);
    dob && formData.append('dob', dob);
    gender && formData.append('gender', gender);
    maritalStatus && formData.append('maritalStatus', maritalStatus);
    aboutMe && formData.append('aboutMe', aboutMe);
    personalEmail && formData.append('personalEmail', personalEmail);
    source && formData.append('source', source);
    referenceBy && formData.append('referenceBy', referenceBy);
    other && formData.append('other', other);

    if (
      presentAddress?.address &&
      presentAddress.city &&
      presentAddress.country &&
      presentAddress.postalCode &&
      presentAddress.state
    ) {
      formData.append('presentAddress', JSON.stringify(presentAddress));
    }

    if (
      permanentAddress?.address &&
      permanentAddress.city &&
      permanentAddress.country &&
      permanentAddress.postalCode &&
      permanentAddress.state
    ) {
      formData.append('permanentAddress', JSON.stringify(permanentAddress));
    }

    if (educationInfo) {
      formData.append('education', JSON.stringify(educationInfo.educationInfo.education));
    }

    if (workExperienceInfo?.workExperience) {
      formData.append('workExperience', JSON.stringify(workExperienceInfo.workExperience));
    }

    if (bankInfo) {
      formData.append('bankInformation', JSON.stringify(bankInfo.bankInfo.bankInformation));
    }

    if (emergencyContactInfo) {
      formData.append('emergencyContact', JSON.stringify(emergencyContactInfo.emergencyContact));
    }

    if (documentInfo) {
      formData.append('aadharFront', documentInfo.documentInfo.aadharFront);
      formData.append('aadharBack', documentInfo.documentInfo.aadharBack);
      formData.append('panFront', documentInfo.documentInfo.panFront);
      formData.append('panBack', documentInfo.documentInfo.panBack);
    }

    formData.append('samePresentAddress', samePresentAddress);

    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const result = yield call(request.put, `${endpoints.updateProfile}${id}`, formData);
    yield put(updateProfileSuccess(result.data));
  } catch (err) {
    yield put(updateProfileFailed(err));
  }
}

function* myProfileSagas() {
  yield all([
    takeLatest(getMyProfile, getmyProfileSagas),
    takeLatest(updateProfile, updateProfileSaga),
  ]);
}

export { myProfileSagas };
